import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { API } from "../../lib/api";
import { useSite } from "../../lib/site";
import { Heart, BedDouble, Ruler, MapPin, Home } from "lucide-react";

export const publicImg = (path) => (path ? `${API}${path}` : null);

export function priceLabel(p, t, money) {
  if (p.sale_price) return money(p.sale_price);
  if (p.rent_price) return `${money(p.rent_price)}${t("per_month")}`;
  return t("price_on_request");
}

export function SiteCard({ p, fav, onFav, i = 0 }) {
  const { t, money, types, lang } = useSite();
  const title = (lang === "en" && p.title_en) || p.title;
  return (
    <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
      className="group relative rounded-2xl overflow-hidden bg-[#122436] border border-white/5 hover:border-[#C9A84C]/40 transition-colors" data-testid={`site-card-${p.id}`}>
      <Link to={`/propriedades/${p.id}`} className="block">
        <div className="relative aspect-[4/3] overflow-hidden bg-[#0A1622]">
          {p.cover_url ? <img src={publicImg(p.cover_url)} alt={title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            : <div className="w-full h-full flex items-center justify-center text-slate-600"><Home size={42} /></div>}
          <div className="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-black/50 to-transparent" />
          <span className="absolute top-4 left-4 text-[10px] uppercase tracking-[0.2em] bg-[#0D1B2A]/85 text-[#E0C574] px-3 py-1 rounded-full">{t(`pu_${p.purpose}`)}</span>
          {p.status !== "disponivel" && <span className="absolute bottom-4 left-4 text-[10px] uppercase tracking-wider bg-white/90 text-[#0D1B2A] px-2.5 py-1 rounded-full font-semibold">{t(`st_${p.status}`)}</span>}
        </div>
        <div className="p-5">
          <p className="text-[11px] uppercase tracking-[0.2em] text-[#C9A84C]">{types[p.property_type]}</p>
          <h3 className="text-lg text-white font-semibold mt-1 line-clamp-1">{title}</h3>
          <p className="text-xs text-slate-400 flex items-center gap-1 mt-1"><MapPin size={12} />{[p.parish, p.municipality].filter(Boolean).join(", ") || p.district}</p>
          <div className="flex items-end justify-between mt-4">
            <span className="text-xl font-display text-[#E0C574]">{priceLabel(p, t, money)}</span>
            <span className="flex gap-3 text-xs text-slate-400">
              {p.bedrooms != null && <span className="flex items-center gap-1"><BedDouble size={14} />{p.bedrooms}</span>}
              {p.area_useful != null && <span className="flex items-center gap-1"><Ruler size={14} />{p.area_useful} m²</span>}
            </span>
          </div>
        </div>
      </Link>
      {onFav && (
        <button onClick={() => onFav(p.id)} data-testid={`site-fav-${p.id}`} aria-label={t("favorites")}
          className="absolute top-3 right-3 w-9 h-9 rounded-full bg-[#0D1B2A]/80 flex items-center justify-center hover:scale-110 transition-transform">
          <Heart size={16} className={fav ? "fill-[#C9A84C] text-[#C9A84C]" : "text-white"} />
        </button>
      )}
    </motion.div>
  );
}
